export const REQUEST_ITINERARY_FETCH_EM = "REQUEST_ITINERARY_FETCH_EM"
export const FETCH_ITINERARY_EM_SUCCESS = "FETCH_ITINERARY_EM_SUCCESS"
export const FETCH_ITINERARY_EM_FAILURE = "FETCH_ITINERARY_EM_FAILURE"

export const CLEAR_FETCH_ITINERARY_EM_STATES = "CLEAR_FETCH_ITINERARY_EM_STATES"